import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import ShopLayout from '../components/shop/ShopLayout';
import { formatPrice } from '../utils/shopHelpers';
import './CheckoutPage.css';
import Seo from '../components/seo/Seo';

function OrderSuccessPage() {
  const { orderNumber } = useParams();
  const location = useLocation();
  const order = location.state?.order;
  const payment = location.state?.payment;

  return (
    <ShopLayout breadcrumbs={[{ label: 'Order Confirmed' }]}>
      <Seo title="Order Confirmed" path={`/order-success/${orderNumber}`} />
      <div className="container checkout-page">
        <div className="checkout-panel" style={{ textAlign: 'center', maxWidth: 560, margin: '0 auto' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
          <h1 style={{ color: '#15803d', marginBottom: 8 }}>Thank You!</h1>
          <p style={{ fontSize: 18, marginBottom: 24 }}>
            Your order <strong>{orderNumber}</strong> has been placed successfully.
          </p>
          {order && (
            <div style={{ textAlign: 'left', marginBottom: 24 }}>
              <p><strong>Order Total:</strong> {formatPrice(order.total)}</p>
              <p><strong>Status:</strong> {order.status}</p>
              <p><strong>Email:</strong> {order.customer_email}</p>
            </div>
          )}
          {payment?.message && (
            <p style={{ background: '#f0fdf4', padding: 12, borderRadius: 4, fontSize: 14 }}>
              {payment.message}
            </p>
          )}
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 24 }}>
            <Link to="/shop" className="auth-form__submit" style={{ display: 'inline-block', textDecoration: 'none', padding: '12px 24px' }}>
              Continue Shopping
            </Link>
            <Link to="/account/orders" style={{ padding: '12px 24px', color: '#2563eb' }}>
              View Orders
            </Link>
          </div>
        </div>
      </div>
    </ShopLayout>
  );
}

export default OrderSuccessPage;
